import Vue from 'vue'

const state = {
  secret: {
    params: {
      brandId: '',
      modelId: '',
      modelIds: '',
      sortId: '',
      statusId: '',
      b2bGradeIds: ''
    },
    checkerObj: {}, // 等级数据
    keyword: '', // 搜索关键词
    verifyCode: '', // 搜索质检码
    saveBrandId: 0, // 暂存品牌值
    saveModelIds: [], // 上次请求的型号数据
    saveLevelIds: [], // 等级选中数据存储
    reset: false,
    saveLevelNames: [], // 存储选中的等级名字
    levelCount: 0, // 等级选中个数
    modelsCount: 0, // 型号选中个数
    attributeCount: 0, // 属性选中个数
    saveParam: {},
    getShoppingCartFlag: false,
    filterToggleFixed: false,
    searchHitData: true, // 搜索是否命中数据
    brandList: [], // 品牌数据
    modelList: [], // 型号数据
    historyList: [], // 历史选择
    levelObj: {}, // 等级数据
    topFilterList: [], // 筛选参数中需要置顶展示的参数项
    filterList: [], // 属性数据
    sortList: [], // 排序数据
    statusList: [], // 状态数据
    attribute: [], // 属性筛选
    sortTitle: '',
    statusTitle: '', // 状态
    brandTitle: '', // 品牌文案
    modelTitle: '', // 型号文案
    showQuickBtnQuickList: [], // 要展示快速删选的按钮的快筛数组
    hasShowQuickParams: null, // 是否拥有要进行快筛的查询信息
    quickBtnClicked: false, // 快筛按钮是否被点击
    gradeTitle: '',
    timeTitle: '',
    sessionTitle: '', // 场次
    subType: '', // 场次ID
    resetVuexDataKeys: [] // 重置时需要重置的单元参数
  }
}

const mutations = {
  // 更改params
  SET_SERECT_PARAMS: (state, params) => {
    const keys = Object.keys(params)
    keys.forEach((key) => {
      Vue.set(state.secret.params, key, params[key])
    })
  },
  SET_SERECT_SAVE_PARAMS: (state, params) => {
    const keys = Object.keys(params)
    keys.forEach((key) => {
      Vue.set(state.secret.saveParam, key, params[key])
    })
  },
  DELETE_SERECT_SAVE_PARAMS: (state, key) => {
    Vue.delete(state.secret.saveParam, key)
  },
  // 重置saveParam
  SAVE_PARAMS_RESET: (state) => {
    Vue.set(state.secret.saveParam, 'labelIds', '')
  },
  // 更改state
  SET_SECRET_STATE: (state, params) => {
    Object.assign(state.secret, params)
  },
  // 重置params
  SET_SERECT_RESET: (state) => {
    const keys = Object.keys(state.secret.params)
    const ignoreKeys = ['cateId', 'auctionType', 'cateSetDef'] // 不需要重置的参数
    keys.forEach((key) => {
      if (ignoreKeys.indexOf(key) < 0) {
        Vue.set(state.secret.params, key, '')
      }
    })
    const stateKeys = Object.keys(state.secret)
    const resetKey = ['sortTitle', 'brandTitle', 'modelTitle', 'gradeTitle', 'statusTitle']
    stateKeys.forEach((key) => {
      if (resetKey.indexOf(key) >= 0) {
        Vue.set(state.secret, key, '')
      }
    })
    Vue.set(state.secret, 'modelList', [])
    Vue.set(state.secret, 'filterList', [])
  },
  // 切换品类重置参数
  SET_SERECT_SAVE_RESET: (state) => {
    const resetKey = [
      'brandList',
      'modelList',
      'saveLevelIds',
      'saveLevelNames',
      'saveModelIds',
      'showQuickBtnQuickList'
    ]
    const stateKeys = Object.keys(state.secret)
    stateKeys.forEach((key) => {
      if (resetKey.indexOf(key) >= 0) {
        Vue.set(state.secret, key, [])
      }
    })
    Vue.set(state.secret, 'saveBrandId', 0)
    Vue.set(state.secret, 'levelCount', 0)
    Vue.set(state.secret, 'levelCount', 0)
    Vue.set(state.secret, 'saveParam', {})
  },
  // 重置属性参数
  FILTER_PARAMS_RESET: () => {
    state.secret.resetVuexDataKeys.forEach((key) => {
      Vue.set(state.secret.params, key, '')
      Vue.set(state.secret.saveParam, key, '')
    })
  },
  // 重置暂存属性参数
  FILTER_SAVE_PARAMS_RESET: () => {
    state.secret.resetVuexDataKeys.forEach((key) => {
      Vue.set(state.secret.saveParam, key, '')
    })
  },
  // 重置params
  SET_FILTER_PARAM_RESET: (state, param) => {
    const keys = Object.keys(state.secret.params)
    const index = keys.indexOf(param)
    if (index > -1) {
      keys.splice(index, 1)
    }
    keys.map((key) => Vue.set(state.secret.params, key, ''))
  },
  // 重置筛选选中数量
  RESET_FILTER_COUNT: (state) => {
    const countArr = ['levelCount', 'modelsCount', 'attributeCount']
    countArr.forEach((item) => {
      for (const ele in state.secret) {
        if (item == ele) {
          state.secret[ele] = 0
        }
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
